import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentGql } from './WorkbooksDisplayGridRowDataFragmentGql';

export const TableDownstreamWorkbooksQueryGql: DocumentNode = gql`
query TableDownstreamWorkbooksQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragment
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentGql}
`;
